import { formatDate, formatNumber } from 'i18n/format';
import { t as translate } from 'i18n';
/** Localized copy for the assistant's fixed error codes and labels. */
import { assistantErrorCode } from 'api/assistant';

export const SAMPLE_QUESTIONS = () => ([
  translate('assistant.copyHowDidMonthlyRevenueChangeOverThe'),
  translate('assistant.copyWhichSourcesBroughtInTheMostOrders'),
  translate('assistant.copyWhatIsTheAverageOrderValueBy'),
]);

const SEND_ERRORS = () => ({
  bad_skill: translate('assistant.copyThisSkillIsUnavailableChooseASkill'),
  bad_reply: translate('assistant.copyCouldNotIdentifyTheOriginalMessageSelect'),
  bad_quote: translate('assistant.copyCouldNotVerifyTheQuoteSelectThe'),
  empty: translate('assistant.copyEnterAQuestion'),
  busy: translate('assistant.copyThePreviousAnswerIsStillBeingPrepared'),
  no_model: translate('assistant.copyNoModelsAvailableAnOwnerOrAdministrator'),
  bad_model: translate('assistant.copyThisModelIsNoLongerAvailableChoose'),
  bad_effort: translate('assistant.copyThisReasoningEffortIsUnavailableForThe'),
  budget_tenant_month: translate('assistant.copyTheWorkspaceHasReachedItsQuestionLimit'),
  budget_user_day: translate('assistant.copyYouHaveReachedYourQuestionLimitFor'),
  budget_platform_month: translate('assistant.copyTheAssistantIsTemporarilyUnavailablePleaseTry'),
  not_found: translate('assistant.assistantPageConversationNotFoundItMayHaveBeen'),
});

const SETTINGS_ERRORS = () => ({
  bad_provider: translate('assistant.copyThisProviderIsUnavailableChooseAnother'),
  bad_family: translate('assistant.copyThisProviderDoesNotOfferThatModel'),
  bad_models: translate('assistant.copyTheAvailableModelsHaveChangedRefreshSettings'),
  consent_required: translate('assistant.copyConsentToSharingDataWithTheProvider'),
  not_admin: translate('assistant.copyOnlyOwnersAndAdministratorsCanChangeThe'),
});

/** What the pending answer says while `count` results are being prepared. */
export function pendingWidgetsText(count) {
  return translate('assistant.preparingResults', { count, formattedCount: formatNumber(count) });
}

/** Why a chart shows as a table (the `fallback` codes of widgetData.js). */
export const FALLBACK_NOTES = () => ({
  units: translate('assistant.copyTheMetricsUseDifferentUnitsAndCannot'),
  shape: translate('assistant.copyThisResultCannotBeDisplayedAsA'),
  pie: translate('assistant.copyAPieChartCannotBeBuiltFrom'),
  kpi: translate('assistant.copyTheResultContainsMultipleRowsSoA'),
  country: translate('assistant.copyCountriesCouldNotBeMatchedToThe'),
  country_duplicate: translate('assistant.copyTheResultContainsMultipleRowsForOne'),
  country_data: translate('assistant.copyThereAreNoNumericValuesForThe'),
});

function transport(err) {
  if (!err?.response) return translate('assistant.copyCannotConnectToTheServerCheckYour');
  if (err.response.status >= 500) return translate('assistant.copyServerErrorPleaseTryAgain');
  return '';
}

/** Message for a failed send (conversation create or message POST). */
export function sendErrorText(err) {
  const code = assistantErrorCode(err);
  return SEND_ERRORS()[code] || transport(err) || translate('assistant.copyCouldNotSendTheMessagePleaseTry');
}

export function settingsErrorText(err) {
  const code = assistantErrorCode(err);
  return SETTINGS_ERRORS()[code] || transport(err) || translate('assistant.copyCouldNotSaveSettings');
}

/** Fixed localized feedback; upstream diagnostics never become product copy. */
export function widgetErrorText(err) {
  return transport(err) || translate('assistant.copyCouldNotLoadResultData');
}



export function formatWhen(iso) {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? formatDate(d, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';
}
